import React from "react"

const LOGO_SRC = "/favicon.svg"

type LogoProps = {
  size?: "sm" | "md"
  withText?: boolean
  onClick?: () => void
}

const Logo: React.FC<LogoProps> = ({ size = "md", withText = true, onClick }) => {
  const iconSizeClasses =
    size === "sm"
      ? "w-7 h-7"
      : "w-8 h-8"

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center space-x-2 cursor-pointer group bg-transparent border-0 p-0 m-0"
      aria-label="Labwick home"
    >
      <img
        src={LOGO_SRC}
        alt="Labwick"
        className={`${iconSizeClasses} rounded-lg object-contain flex-shrink-0 shadow-sm group-hover:shadow-md transition-shadow`}
      />
      {withText && (
        <span className="font-bold text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors text-base leading-tight">
          LABWICK
        </span>
      )}
    </button>
  )
}

export default Logo

